import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Row, Col, notification, DatePicker, Drawer, Tabs, Tooltip, Checkbox, Select, } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { connect } from "react-redux";

import CompanyDetails from '../../../components/Invoice/companyDetails';
import SelectedStudentInvoices from '../../../components/Invoice/selectedStudentInvoices';
import WithdrawStudentReasonForm from '../../../components/Invoice/withdrawStudentReasonForm';

import Settings from "../../../components/_utils/settings";

import lodash from "lodash";

import userRights from "../../../components/_utils/userRights";
import { RightsWrapper } from '../../../components/_utils/utils'
import FileViewer from 'react-file-viewer';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const TabPane = Tabs.TabPane
const Option = Select.Option
let localUser = JSON.parse(localStorage.getItem('user'))

const { RangePicker, MonthPicker } = DatePicker

let desks = {
  'Front Desk': '/desk/update-counselling',
  'Registration Desk': '/registration/fees',
  'Application Desk': '/desk/allApplication-desk/update',
  'Visa Desk': '/desk/getVisa',
  'Claim Desk': '/desk/getClaim',
  'Operation Manager Desk': '/operation-manager-inquiry/update'
};

class ShowUniversityAgreement extends React.Component {
  state = {
    visible: true
  }
  componentDidMount() {
  }

  onError = () => {
    notification.error({
      message: 'File type not supported, try to download it.'
    })
    this.setState({
      visible: false
    })

    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  render() {
    let { visible } = this.state
    let { record } = this.props
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              University Agreement
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}
      >
        <Card>
          <FileViewer
            fileType="pdf"
            filePath={`${API_URL}${record.universityId.paymentUpload && record.universityId.paymentUpload[0] ? record.universityId.paymentUpload[0].url : null}`}
            onError={this.onError} />
        </Card>
      </Drawer>
    )
  }
}

class AllFinance extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universityId: '',
    universities: [],
    channelPartners: [],
    courses: [],
    allBranches: [],
    branchArray: [],
    showSelectedInvoices: false,
    selectMultipleRecords: [],
    selectMultipleRecordsData: [],
    selectedRecords: [],
    defaultPageSize: 100,
    showAvailableInvoice: false,
    showCompanyDetailForm: false,
    showWithdrawForm: false,
    companyBankId: '',
    selectedSemester: [],
    universityInstitutionName: '',
    channelPartnerId: '',
    recordId: '',
    universities: [],
    enableBTN: false,
    time: {
      from: null,
      to: null
    },
    courseStartDate: [],
    selectedDates: [],
    invoiceGenerationRecord: {},
    pendingUniversityTotal: 0,
    showPendingAgreementDrawer: false,
    pendingAgreementRecord: {}
  }

  onChangeDatePicker = (date) => {
    let { courseStartDate, selectedDates } = this.state;
    let selectedDate = moment(date).format('YYYY-MMM');
    if (selectedDates.includes(selectedDate)) {
      const index = selectedDates.indexOf(selectedDate);
      if (index > -1) {
        selectedDates.splice(index, 1);
        courseStartDate.splice(index, 1);
      }
    } else {
      courseStartDate.push({
        from: moment(date).startOf('month').format('YYYY-MM-DD'),
        to: moment(date).endOf('month').format('YYYY-MM-DD')
      });
      selectedDates.push(moment(date).format('YYYY-MMM'));
    }
    this.setState({
      courseStartDate, selectedDates
    }, () => {
      this.table.current.reload();
    });
  }

  pendingAgreementsRequest = params => {
    return new Promise(async resolve => {
      params.status = "Pending"
      params.sortField = "universityInstitutionName";
      params.sortOrder = "ascend"
      let response = await Request.getCommissionUniversities(params);
      this.setState({ pendingUniversityTotal: response.total })
      resolve(response)
    })
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { showAvailableInvoice, courseStartDate, channelPartnerId, studentBranchId, selectedSemester, universityInstitutionName, defaultPageSize } = this.state;

      this.setState({ exportParams: params })

      params.selectSemester = selectedSemester;
      if (universityInstitutionName) {
        params.universityInstitutionName = universityInstitutionName;
      }
      if (channelPartnerId) {
        params.channelPartnerId = channelPartnerId;
      }

      if (studentBranchId) {
        params.studentBranchId = studentBranchId;
      }

      if (this.state.courseStartDate) {
        params['courseStartDate'] = courseStartDate;
      }

      if (this.state.time && this.state.time.from) {
        params['nextInvoiceGenerationDates.generationDate'] = {
          $gte: this.state.time.from,
          $lte: this.state.time.to
        };
      }

      let searchParams = new URLSearchParams(this.props.search);
      let invId = searchParams.get("invId");

      if (invId) {
        params["nextInvoiceGenerationDates._id"] = invId;
      }

      let data = await Request.getNextInvoiceGenerated({
        ...params,
        regExFilters: [
          'studentName'
        ]
      });
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  showAgreementDrawer = (record) => {
    this.setState({ showPendingAgreementDrawer: true, pendingAgreementRecord: record })
  }

  showAvailableInvoices = () => {
    let showAvailableInvoice = this.state.showAvailableInvoice;
    this.setState({ showAvailableInvoice: (showAvailableInvoice == false ? true : false) });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }

  loadUniversity = async () => {
    Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
      .then(resp => {
        resp.arr = resp.arr.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.universityInstitutionName })
          return temp
        }, [])

        this.setState({ universities: resp.arr });
      })
      .catch(err => {
        console.log(err)
      })
  }

  loadChannelPartner = async () => {
    Request.loadChannelPartners({
      count: 1000,
      results: 1000
    })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.channelPartnerName })
          return temp
        }, [])

        this.setState({ 'channelPartners': resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  componentWillMount() {
  }

  async componentDidMount() {
    await this.loadUniversity();
    await this.loadChannelPartner();
    const { showInvoice } = this.props
    // if (showInvoice == 'today') {
    //   let weakStartDate = moment().startOf('day').format()
    //   let weakEndDate = moment().endOf('day').format()
    //   this.setState({
    //     time: {
    //       from: weakStartDate,
    //       to: weakEndDate
    //     }
    //   }, () => {
    //     this.table.current.reload();
    //   })
    // }
    let { data: branchArr } = await Request.getAllSimpleBranch({ results: 10000, sortField: 'branchName', sortOrder: 'ascend', status: true })
    let allBranches = [];
    let branchArray = []
    _.each(branchArr, (item) => {
      allBranches.push({ value: item._id, text: item.branchName })
      branchArray[item._id] = [];
      branchArray[item._id].push(item.branchName);
    })
    this.setState({ allBranches, branchArray })
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.table1 = React.createRef()
  }
  handleChange = (value) => {
    this.setState({
      selectedSemester: value
    }, () => {
      this.table.current.reload();
    })
  }

  withdrawStudent = async (data) => {
    if (!data.withdrawReason) {
      return notification.error({
        message: 'Please enter withdraw reason.'
      })
    }
    let invoiceGenerationRecord = data;
    data.invoiceGeneratedRecordId = invoiceGenerationRecord._id
    data.recordId = data.recordId._id;
    let response = await Request.withdrawStudent(data);
    if (!response.error) {
      if (this.table && this.table.current) {
        this.table.current.reload();
      }
      this.setState({ showWithdrawForm: false })
      notification.success({ message: response.msg });
    } else {
      notification.error({
        message: 'Error withdraw student.'
      })
    }
  }

  doGenerateMultipleInvoices = () => {
    let selectMultipleRecords = this.state.selectMultipleRecords;
    let count = 0;
    for (const key in selectMultipleRecords) {
      if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
        const selectMultipleRecord = selectMultipleRecords[key];
        if (selectMultipleRecord.universityId) {
          count++;
        }
      }
    }
    if (count == 0) {
      notification.error({
        message: 'Please select atleast 1 record.'
      });
      return false;
    }
    this.selectCompanyDetails();
  }

  selectCompanyDetails = async () => {
    this.setState({ showCompanyDetailForm: true });
  }

  closeDocument = () => {
    this.setState({ showCompanyDetailForm: false });
  }

  closeWithdrawFrom = () => {
    this.setState({ showWithdrawForm: false });
  }

  selectCompanyBankId = () => {
    this.setState({ enableBTN: false, showCompanyDetailForm: false }, () => {
      this.setState({ selectMultipleRecords: [] });
    });
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }

  selectAllUserFxn = () => {
    let selectedRecords = this.state.selectedRecords;
    let selectMultipleRecords = this.state.selectMultipleRecords;
    for (const selectedRecordKey in selectedRecords) {
      if (Object.hasOwnProperty.call(selectedRecords, selectedRecordKey)) {
        const selectedRecord = selectedRecords[selectedRecordKey];
        let invoiceGeneratedRecordId = selectedRecord.invoiceGeneratedRecordId;
        let studentId = selectedRecord.studentId;
        let universityId = selectedRecord.universityId;

        for (const key in selectMultipleRecords) {
          if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
            const selectMultipleRecord = selectMultipleRecords[key];
          }
        }
        selectMultipleRecords[studentId] = {
          universityId,
          studentId,
          invoiceGeneratedRecordId
        };
      }
    }
    this.setState({ selectMultipleRecords: selectMultipleRecords });
  }
  unselectAllUserFxn = () => {
    this.setState({ selectMultipleRecords: [] });
  }

  selectMultiRecords = (e, record, invoiceGenerationRecord, index) => {
    let invoiceGeneratedRecordId = invoiceGenerationRecord._id;
    let studentId = record._id;
    let studentIdKey = `${studentId}-${index}`
    let universityId = record.visaDesk.selectedCourse.universityId;
    let selectMultipleRecords = this.state.selectMultipleRecords;

    let selectedCourse = record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse : {};
    let tutionFee = selectedCourse.tutionFee ? selectedCourse.tutionFee : 0;

    if (e.target.checked == true) {
      selectMultipleRecords[studentIdKey] = {
        universityId,
        studentId,
        invoiceGeneratedRecordId,
        tutionFee,
        record
      };
    } else {
      if (selectMultipleRecords[studentIdKey] != undefined) {
        delete selectMultipleRecords[studentIdKey];
      }
    }
    this.setState({ selectMultipleRecords: selectMultipleRecords });
  }

  printInvoiceDate = (nextInvoiceGenerationDates) => {
    if (nextInvoiceGenerationDates.length) {
      let generatedInvoices = nextInvoiceGenerationDates.filter(item => (item.invoiceGenerated === undefined || item.invoiceGenerated === false || !item.invoiceGenerated));
      return generatedInvoices.length > 0 ? generatedInvoices[0] : {};
    } else {
      return {};
    }
  }

  generateInoice = async (record, invoiceGenerationRecord, index) => {
    let invoiceGeneratedRecordId = invoiceGenerationRecord._id;
    let universityId = record.visaDesk.selectedCourse.universityId;

    let selectedCourse = record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse : {};
    let tutionFee = selectedCourse.tutionFee ? selectedCourse.tutionFee : 0;
    let studentId = record._id;
    let studentIdKey = `${studentId}-${index}`
    let selectMultipleRecords = [];
    selectMultipleRecords[studentIdKey] = {
      universityId,
      studentId,
      invoiceGeneratedRecordId,
      tutionFee,
      record
    };
    this.setState({ selectMultipleRecords: selectMultipleRecords });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.selectCompanyDetails();
      }
    }, 500);
  }

  getOverdueClass = (generationDate) => {
    if (generationDate && moment(generationDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
      return 'red-overdue';
    }
    return '';
  }

  updateUniversityAgreement = async (data) => {
    let response = await Request.updateUniversityCommissionStatus(data);
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table1.current.reload();
  }

  chooseRangerPickerApplicationDesk = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] !== undefined) {
          this.table.current.reload()
        }
      }
    )
  }

  onOk = value => {
    this.table.current.reload()
  }

  closeAgreementDrawer = () => {
    this.setState({ pendingAgreementRecord: {}, showPendingAgreementDrawer: false }, () => {
      this.table1.current.reload()
    })
  }

  returnDeskName = (record) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == record.atLevel;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {
            localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
              <a
                style={{ color: 'white' }}
                size={"small"}
                href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
              >{Settings.deskNameObj[record.atLevel]}</a>
              :
              Settings.deskNameObj[record.atLevel]
          }
        </div>
      );
    } else {
      return <div>{record.atLevel}</div>;
    }
  };


  showSelectedStudentDrawr = () => {
    let selectMultipleRecords = this.state.selectMultipleRecords
    let count = 0;
    for (const key in selectMultipleRecords) {
      if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
        const selectMultipleRecord = selectMultipleRecords[key];
        if (selectMultipleRecord.universityId) {
          count++;
        }
      }
    }
    if (count == 0) {
      return notification.warning('Please select atleast 1 student to generate invoice.');
    } else {
      this.setState({ selectMultipleRecordsData: selectMultipleRecords, showSelectedInvoices: true })
    }
  }
  closeStudentInvoiceDrawr = () => {
    this.setState({ showSelectedInvoices: false })
  }

  render() {
    const { dispatch, showPageWrapper, showInvoice } = this.props

    const {
      selectMultipleRecordsData, invoiceGenerationRecord, showSelectedInvoices, allBranches, branchArray, selectedDates, universities, channelPartners, total, selectMultipleRecords, enableBTN, showAvailableInvoice, defaultPageSize, showCompanyDetailForm, showWithdrawForm, recordId } = this.state;
    let { channelPartnerId, studentBranchId, selectedSemester, universityInstitutionName } = this.state;
    let count = 0;
    for (const key in selectMultipleRecords) {
      if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
        const selectMultipleRecord = selectMultipleRecords[key];
        if (selectMultipleRecord.universityId) {
          count++;
        }
      }
    }

    const columns = [
      {
        title: 'Action',
        key: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
        dataIndex: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
        searchTextName: 'Invoice Number',
        width: 250,
        render: (generationDates, record) => (
          <React.Fragment>
            {
              record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0 ?
                <table className='ant-table ant-table-bordered' style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Invoice</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      record.nextInvoiceGenerationDates.map((date, index) => {
                        let studentIdKey = `${record._id}-${index}`
                        let ifChecked = selectMultipleRecords[studentIdKey] && selectMultipleRecords[studentIdKey].invoiceGeneratedRecordId == date._id ? true : false;
                        let url = `/finance-desk?invSTId=${(date._id)}`;
                        return (
                          <tr key={index} className={(date.invoiceGeneratedNumber ? 'invoice-done' : this.getOverdueClass(date.generationDate) == 'red-overdue' ? 'red-overdue' : 'pending-invoice')}>
                            <td>
                              {
                                date.withdrawRequest == true ?
                                  <small>Withdrawn</small>
                                  :
                                  (
                                    date.invoiceGeneratedNumber ?
                                      <small><a
                                        target={"_blank"}
                                        href={url}
                                      >
                                        {date.invoiceGeneratedNumber}
                                      </a></small>
                                      :
                                      <>
                                        <Tooltip title="Click To Generate Invoice">
                                          &nbsp;&nbsp;&nbsp;<Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.generateInoice(record, date, index) }}
                                            shape="circle"
                                            icon="check"
                                          />
                                        </Tooltip>
                                        <Tooltip title="Withdraw Student">
                                          &nbsp;<Button
                                            loading={false}
                                            className={styles.btn}
                                            onClick={() => { this.setState({ recordId: record, invoiceGenerationRecord: date, showWithdrawForm: true }) }}
                                            shape="circle"
                                            icon="close"
                                          />
                                        </Tooltip>
                                        <Checkbox
                                          checked={ifChecked}
                                          onChange={(e) => { this.selectMultiRecords(e, record, date, index) }}>
                                        </Checkbox>
                                      </>
                                  )
                              }
                            </td>
                            <td>{moment(date.generationDate).format(dateFormat)}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
                :
                <small style={{ color: '#ed1c24', fontSize: '12px' }}>Dates Not Added Yet!!!.</small>
            }
          </React.Fragment>
        )
      },
      {
        title: 'Approval Date',
        key: 'visaDesk.visaApprovalDate',
        width: 110,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                {moment(text).format(dateFormat)}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'VID',
        key: 'id',
        dataIndex: 'id',
        width: 120,
        searchTextName: 'id',
        filterRegex: true,
        render: (text, record) => (
          <div>
            <div> <b> {record.id} </b> </div>
            {
              this.getOverdueClass(record.nextInvoiceGenerationDates) == 'red-overdue' ?
                <p className={this.getOverdueClass(record.nextInvoiceGenerationDates)}>This invoice overdue.</p>
                : null
            }
          </div>
        )
      },
      {
        title: 'Student Name',
        key: 'studentName',
        dataIndex: 'studentName',
        width: 120,
        searchTextName: 'studentName',
        filterRegex: true,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                <Tooltip title="Click To Edit Details">
                  <a className={styles.btn} style={{ color: '#000' }} target={'_blank'}
                    href={`/desk/getClaim?id=${record._id}`}
                  >{text}</a>
                </Tooltip>
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Passport NO',
        key: 'visaDesk.passportNo',
        dataIndex: 'visaDesk.passportNo',
        width: 110,
        searchTextName: 'visaDesk.passportNo',
        filterRegex: true,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.passportNo ? record.visaDesk.passportNo : record.profile.passportNumber}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'DOB',
        key: 'dateOfBirth',
        dataIndex: 'dateOfBirth',
        width: 90,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {moment(record.dateOfBirth).format(dateFormat)}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Desk',
        key: 'atLevel',
        dataIndex: 'atLevel',
        width: 90,
        render: (text, record) => {
          return this.returnDeskName(record);
        }
      },
      {
        title: 'Institute ID',
        key: 'visaDesk.selectedCourse.instituteStudentId',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.instituteStudentId : 'NA'}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Channel Partner',
        key: 'visaDesk.selectedCourse.channelPartnerName',
        dataIndex: 'visaDesk.selectedCourse.channelPartnerName',
        width: 140,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.channelPartnerName : 'NA'}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Branch',
        key: 'studentBranchId',
        dataIndex: 'studentBranchId',
        width: 70,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {branchArray[record.studentBranchId]}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Institute',
        key: 'visaDesk.selectedCourse.universityInstitutionName',
        dataIndex: 'visaDesk.selectedCourse.universityInstitutionName',
        width: 170,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.universityInstitutionName : 'NA'}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Course',
        key: 'visaDesk.selectedCourse.courseName',
        dataIndex: 'visaDesk.selectedCourse.courseName',
        width: 170,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.courseName : ''}\
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Country',
        key: 'visaDesk.selectedCourse.countryName',
        dataIndex: 'visaDesk.selectedCourse.countryName',
        width: 70,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.countryName : ''}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Currency',
        key: 'visaDesk.selectedCourse.currency',
        dataIndex: 'visaDesk.selectedCourse.currency',
        width: 70,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.currency : ''}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Tution Fee',
        key: 'visaDesk.selectedCourse.tutionFee',
        dataIndex: 'visaDesk.selectedCourse.tutionFee',
        width: 70,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.tutionFee : ''}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Intakes',
        key: 'visaDesk.courseStartDate',
        width: 70,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {text
                ? moment(text).format('MMM-YYYY')
                : ''}
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Start Date',
        key: 'visaDesk.courseStartDate1',
        width: 90,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              {record.visaDesk.courseStartDate
                ? moment(record.visaDesk.courseStartDate).format(dateFormat)
                : ''}
            </React.Fragment>
          </div>
        )
      }
    ];

    let innerHtml = [];
    innerHtml.push(
      <>
        <Card style={{ marginBottom: 10 }}
          title={(showPageWrapper == true ? `Search Filters` : `Today's Pending Invoices: ${total}`)}
          headStyle={{ paddingTop: '5px' }}
          bordered={false}>
          <Row>
            <Col span={6}>
              <h4>Search By Invoice Date</h4>
              <RangePicker
                defaultValue={[this.state.time.from, this.state.time.to]}
                style={{ width: '250px' }}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPickerApplicationDesk}
                onOk={this.onOk}
              />
            </Col>
            <Col span={6}>
              <h4>Search By University</h4>
              <Select
                allowClear
                style={{ width: '250px' }}
                showSearch={true}
                placeholder="Select University"
                optionFilterProp="universityInstitutionName"
                value={universityInstitutionName}
                onChange={(v) => this.setState({ universityInstitutionName: v }, () => { this.table.current.reload(); })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  universities.map((val, idn) => {
                    return (
                      <Option key={idn} value={val._id}>
                        {val.display}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={6}>
              <h4>Search By Channel Partner</h4>
              <Select
                allowClear
                style={{ width: '250px' }}
                showSearch={true}
                placeholder="Select Channel Partner"
                optionFilterProp="channelPartnerId"
                value={channelPartnerId}
                onChange={(v) => this.setState({ channelPartnerId: v }, () => { this.table.current.reload(); })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  channelPartners.map((val, idn) => {
                    return (
                      <Option key={idn} value={val._id}>
                        {val.display}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={6}>
              <h4>Search By Branch</h4>
              <Select
                allowClear
                style={{ width: '250px' }}
                showSearch={true}
                placeholder="Select branch"
                optionFilterProp="studentBranchId"
                value={studentBranchId}
                onChange={(v) => this.setState({ studentBranchId: v }, () => { this.table.current.reload(); })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  allBranches.map((val, idn) => {
                    return (
                      <Option key={idn} value={val.value}>
                        {val.text}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={6}>
              <h4>Search By Term</h4>
              <Select
                defaultValue='Select Semester'
                style={{ width: '250px' }}
                showSearch={true}
                allowClear
                mode='multiple'
                onChange={this.handleChange}
                value={selectedSemester}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}
              >
                <Option value='0'>1st Semester</Option>
                <Option value='1'>2nd Semester</Option>
                <Option value='2'>3rd Semester</Option>
                <Option value='3'>4th Semester</Option>
                <Option value='4'>5th Semester</Option>
                <Option value='5'>6th Semester</Option>
              </Select>
            </Col>
            <Col span={6}>
              <h4>Search By Intake</h4>
              <MonthPicker style={{ width: '250px' }} format="YYYY-MMM" onChange={this.onChangeDatePicker} placeholder="Select Intake" />
            </Col>
            <Col span={6}>
              <h4>Selected Intakes</h4>
              <b>{selectedDates.join(', ')}</b>
            </Col>
            <Col span={6}>
              <h4>&nbsp;</h4>
              <Button
                className={styles.btn}
                onClick={() => { this.table.current.reload() }}>Search
              </Button>
              <Button
                className={styles.btn}
                onClick={() => {
                  this.setState({
                    selectedDates: [],
                    courseStartDate: [],
                    selectedSemester: [],
                    studentBranchId: '',
                    channelPartnerId: '',
                    universityInstitutionName: '',
                    time: {
                      from: '',
                      to: ''
                    }
                  }, () => {
                    this.table.current.reload();
                  })
                }}>Reset
              </Button>
            </Col>
          </Row>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <div className={styles.filterBlock}>
            <div className={styles.myBtnGroup}>
              <div className='antd-pro-containers-finance-all-styles-myBtnGroup'>
                <Button
                  type={showAvailableInvoice == true ? 'primary' : 'info'}
                  className={styles.btn}
                  onClick={() => this.showAvailableInvoices()}> Show Available Invoices
                </Button>
                {
                  count > 0 ?
                    <Button onClick={this.showSelectedStudentDrawr.bind()} style={{ background: 'green', color: '#fff' }}>Selected Students:- {count}</Button>
                    : null
                }
              </div>
              <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                <Button
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.doGenerateMultipleInvoices()}> Generate Group Invoice
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.selectAllUserFxn()}>Select All
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.unselectAllUserFxn()}>UnSelect All
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            id={'finance_cliam_desk'}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </>
    );

    const pendingUniversitiesColumns = [
      {
        title: 'Action',
        key: 'operation',
        fixed: 'left',
        width: 120,
        render: (text, record) => {
          return (
            <>
              <Tooltip title="Approve University Agreement">
                <Button size='small' shape='circle' icon='check' onClick={() => this.updateUniversityAgreement({ _id: record._id, status: 'Active' })}></Button>
              </Tooltip>
              <Tooltip title="Disapprove University Agreement">
                <Button style={{ marginLeft: 5 }} size='small' shape='circle' icon='cross' onClick={() => this.updateUniversityAgreement({ _id: record._id, status: 'Inactive' })}></Button>
              </Tooltip>
            </>
          )
        }
      },
      {
        title: 'University Name',
        key: 'universityInstitutionName',
        width: 200,
        fixed: 'left',
        searchTextName: 'universityInstitutionName',
        filterRegex: true
      },
      {
        title: 'Country',
        width: 80,
        key: 'universityId.universityCountryName',
        searchTextName: 'universityCity',
        dataIndex: 'universityId.universityCountryName',
      },
      {
        title: 'Partnership',
        key: 'universityPartnership',
        dataIndex: 'universityPartnership',
        sorter: true,
        width: 150
      },
      {
        title: 'Commission From University',
        key: 'commissionFromUniversity',
        dataIndex: 'commissionFromUniversity',
        sorter: true,
        width: 150,
        render: (text, record) => {
          return (
            `${record.commissionFromUniversity} ${record.commissionTypeFrom === "Percentage" ? ("%") : `(${record.commissionTypeFrom})`}`
          )
        }
      },
      {
        title: 'Agreement',
        key: 'paymentUpload',
        width: 120,
        render: (text, record) => {
          return (
            <Button icon='eye' onClick={() => this.showAgreementDrawer(record)}></Button>
          )
        }
      },
      {
        title: 'Category',
        key: 'universityCategory',
        dataIndex: 'universityCategory',
        sorter: true,
        // searchTextName: 'universityCategory',
        width: 150
      },
      {
        title: 'University Type',
        key: 'universityType',
        dataIndex: 'universityType',
        sorter: true,
        // searchTextName: 'universityCategory',
        width: 150
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        sorter: true,
        width: 150
      }
    ]

    return (

      <div>
        {
          this.state.showPendingAgreementDrawer ?
            <ShowUniversityAgreement record={this.state.pendingAgreementRecord} onClose={this.closeAgreementDrawer} />
            : null
        }
        {
          showCompanyDetailForm ?
            <CompanyDetails selectMultipleRecords={selectMultipleRecords} enableBTN={enableBTN} onClose={this.closeDocument} onSelect={(e) => this.selectCompanyBankId(e)} />
            : null
        }
        {
          showWithdrawForm ?
            <WithdrawStudentReasonForm onClose={this.closeWithdrawFrom} onSelect={(e) => this.withdrawStudent(e)} recordId={recordId} invoiceGenerationRecord={invoiceGenerationRecord} enableBTN={enableBTN} />
            : null
        }
        {
          showSelectedInvoices ?
            <SelectedStudentInvoices selectMultipleRecords={selectMultipleRecordsData} onClose={this.closeStudentInvoiceDrawr.bind()} />
            : null
        }
        {/* <RightsWrapper myRight={"approvePendingAgreement.view"}>
          <Card title={`Pending University Commission Approval: ${this.state.pendingUniversityTotal}`} style={{ marginBottom: 10 }} bordered={true}>
            <TableComp
              ref={this.table1}
              columns={pendingUniversitiesColumns}
              apiRequest={this.pendingAgreementsRequest}
              extraProps={{ scroll: { x: 1400 } }}
              pagination={{
                showSizeChanger: true,
                defaultPageSize: '20',
                pageSizeOptions: ['10', '20', '50', '100', '1000']
              }}
            />
          </Card>
        </RightsWrapper> */}
        {
          showPageWrapper == true ?
            <PageHeaderWrapper title={` Invoice Desk: ${total} `}>
              {innerHtml}
            </PageHeaderWrapper>
            :
            <div>
              {innerHtml}
            </div>
        }
      </div>

    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllFinance);
